import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import { sanitizeEventDescription } from '../../utils/eventDescription';

interface EventDescriptionDisplayProps {
  content?: string | null;
  sx?: SxProps<Theme>;
}

const EventDescriptionDisplay: React.FC<EventDescriptionDisplayProps> = ({ content, sx }) => {
  const safeHtml = sanitizeEventDescription(content);

  if (!safeHtml) {
    return null;
  }

  return (
    <Box
      component="div"
      sx={{
        whiteSpace: 'pre-wrap',
        '& p': { margin: 0, mb: 1 },
        '& ul, & ol': { margin: 0, paddingLeft: 2 },
        '& li': { marginBottom: 0.5 },
        '& strong, & b': { fontWeight: 700 },
        '& em, & i': { fontStyle: 'italic' },
        '& u': { textDecoration: 'underline' },
        ...sx,
      }}
      dangerouslySetInnerHTML={{ __html: safeHtml }}
    />
  );
};

export default EventDescriptionDisplay;
